import React from "react";
import { Link } from "gatsby";
import { Caret } from "@images/icons";
import { StatesData } from "@components/templates/store-locator";
import { Store } from "@storeLocator/storeType";
import wordsToUrl from "@utils/wordsToUrl";
import { SPSection } from ".";

interface SPServicesSectionProps {
  stateProductInfo: StatesData;
  store: Store;
}

const SPServicesSection = ({
  stateProductInfo,
  store,
}: SPServicesSectionProps) => {
  const currentStateData = stateProductInfo.find(
    (state) => state.elements.state_abbreviation.value === store.province
  );

  const renderLinkItem = (item: any, isProduct = true) => {
    const itemName = isProduct ? item.elements.product_name.value : item.name;
    let itemPath = isProduct
      ? `/${wordsToUrl(itemName)}`
      : `/store-services#${wordsToUrl(itemName)}`;

    // Check if the path is "express-title-loans" and change it to "title-loans"
    if (itemPath === "/express-title-loans") {
      itemPath = "/title-loans";
    }

    return (
      <Link
        className="flex items-center justify-between border-b border-b-[#51B9AC] px-4 py-1.5 font-body tracking-[0.16px] text-midnight transition-colors hover:bg-abyss/20 lg:px-8 lg:py-2.5"
        key={itemName}
        to={itemPath}
      >
        <div className="lg:text-lg">
          <h3 className="font-bold">{itemName}</h3>
          {isProduct ? <p>Up to ${item.elements.max_amount.value}</p> : <br />}
        </div>
        <div className="flex h-5 w-5 items-center justify-center rounded-full bg-salmon shadow-default lg:h-7 lg:w-7">
          <Caret className="w-3.5 stroke-redWood lg:w-5" />
        </div>
      </Link>
    );
  };

  return (
    <SPSection headline="Services" className="pb-12 lg:pb-20">
      <div>
        {currentStateData?.elements.products.value.map((product) =>
          renderLinkItem(product)
        )}
        {currentStateData?.elements.in_store_services.value.map((service) =>
          renderLinkItem(service, false)
        )}
      </div>
    </SPSection>
  );
};

export default SPServicesSection;
